import { API_BASE_URL } from "../apiConfig";
import React, { createContext, useState, useEffect, useContext } from "react";

const LocationContext = createContext();

export const LocationProvider = ({ children }) => {
  const [locationStatus, setLocationStatus] = useState("Initializing...");
  const [lastLocation, setLastLocation] = useState(null);

  useEffect(() => {
    const syncLocation = () => {
      const sessionStored = sessionStorage.getItem("currentUser");
      if (!sessionStored) {
        setLocationStatus("Waiting for Login...");
        return;
      }

      try {
        const user = JSON.parse(sessionStored);
        if (user.role !== "driver" || !user.username) {
          setLocationStatus("Tracking Idle (Not Driver)");
          return;
        }

        if (!navigator.geolocation) {
          setLocationStatus("❌ Geolocation not supported");
          return;
        }

        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const { latitude, longitude } = pos.coords;
            setLastLocation({ lat: latitude, lng: longitude });
            
            fetch(`${API_BASE_URL}/api/driver/update-location`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                username: user.username,
                lat: latitude,
                lng: longitude,
              }),
            })
              .then(res => res.json())
              .then(() => {
                setLocationStatus(`✅ Active: ${latitude.toFixed(4)}, ${longitude.toFixed(4)}`);
              })
              .catch(err => setLocationStatus(`❌ Sync Failed: ${err.message}`));
          },
          (err) => {
            setLocationStatus(`❌ ${err.message}`);
          },
          { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
        );
      } catch (e) {
        console.error("Location tracking error:", e);
      }
    };

    syncLocation();
    const interval = setInterval(syncLocation, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <LocationContext.Provider value={{ locationStatus, lastLocation }}>
      {children}
    </LocationContext.Provider>
  );
};

export const useLocation = () => useContext(LocationContext);
